import Vue from 'vue';

import {
    Cascader

} from 'element-ui';

export const JtCascader = Vue.extend({
    extends: Cascader,
    methods: {
        computePresentTags() {

            const { isDisabled, leafOnly, showAllLevels, separator, collapseTags } = this;
            const checkedNodes = this.getCheckedNodes(leafOnly);
            const tags = [];

            const genTag = node => {
                let text_join = ''
                let text_splice = node.getText(showAllLevels, separator).split(separator);
                if(text_splice.length > 2) {
                    text_join = text_splice.slice(-2).join(separator)
                }else{
                    text_join = text_splice.join(separator)
                }
                return ({
                    node,
                    key: node.uid,
                    text: text_join,
                    hitState: false,
                    closable: !isDisabled && !node.isDisabled
                  })
            };

            if (checkedNodes.length) {
              const [first, ...rest] = checkedNodes;
              const restCount = rest.length;
              tags.push(genTag(first));

              if (restCount) {
                if (collapseTags) {
                  tags.push({
                    key: -1,
                    text: `+ ${restCount}`,
                    closable: false
                  });
                } else {
                  rest.forEach(node => tags.push(genTag(node)));
                }
              }
            }

            this.checkedNodes = checkedNodes;
            this.presentTags = tags;
          },
    }
});
